import styled from 'styled-components'

export const StyledMyPageMySpecifications = styled.div`
  padding: 0 15px;
`
